<div class="filter-panel body-content-label" >
  {{headerTitle}}<span data-toggle="collapse" (click)="isCollapsed = !isCollapsed" [attr.data-target]="dataTargetId" style="float: right;cursor: pointer;">{{ isCollapsed? '+': '&ndash;' }}</span>
</div>
